import React from 'react';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';
const blogData = [

  {
    title: 'Why Regular Health Checkups Are Important for Every Family',
    thumbUrl: '/images/real/blog_1.png',
    date: 'January 15',
    btnText: 'Learn More',
    href: '/blog/health-checkups-importance',
  },
  {
    title: 'Understanding Blood Tests and What They Reveal About Your Health',
    thumbUrl: '/images/real/blog_2.png',
    date: 'January 22',
    btnText: 'Learn More',
    href: '/blog/understanding-blood-tests',
  },
  {
    title: 'How Ultrasound and Digital X-Ray Help in Early Diagnosis',
    thumbUrl: '/images/real/blog_3.png',
    date: 'February 1',
    btnText: 'Learn More',
    href: '/blog/ultrasound-xray-diagnosis',
  },

];

export default function Blog() {
  pageTitle('Blog');
  return (
    <>
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title="Your Health,Our Priority" />
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <BlogSectionStyle2 data={blogData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/real/cta_banner.png"
        />
      </Section>
    </>
  );
}
